var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header-actions"
  }, [_vm.isWidest ? [_c('div', {
    staticClass: "d-flex"
  }, [_c('r-button-simple', {
    class: _vm.isWidest ? 'mr-3' : 'mr-2',
    attrs: {
      "icon": "update",
      "type": "transparent",
      "color": "harakiri",
      "size": "spelino"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleTheme();
      }
    }
  }), _c('NotificationHandler', {
    attrs: {
      "unreadMessagesCount": _vm.unreadMessagesCount,
      "isNotifyPanelShow": _vm.isNotifyPanelShow
    },
    on: {
      "toggleNotifications": function ($event) {
        return _vm.toggleNotifications();
      }
    }
  })], 1)] : _vm._e(), _vm.lteWide ? [_vm.headerInfo.backButton ? [_c('r-button-simple', {
    class: _vm.isWidest ? 'w-mr-12' : 'w-mr-8',
    attrs: {
      "icon": "arrow-left",
      "type": "transparent",
      "color": "harakiri",
      "size": "spelino"
    },
    on: {
      "click": function ($event) {
        return _vm.headerInfo.clickBackCallback();
      }
    }
  })] : _vm._e(), _vm.headerInfo.actions ? _vm._l(_vm.headerInfo.actions, function (button) {
    return _c('r-button-simple', {
      key: button.iconClassName,
      class: _vm.isWidest ? 'w-mr-12' : 'w-mr-8',
      attrs: {
        "disabled": button.disabled,
        "icon": button.iconClassName,
        "type": "transparent",
        "color": "harakiri",
        "size": "spelino"
      },
      on: {
        "click": function ($event) {
          return button.clickEventCallback();
        }
      }
    });
  }) : _vm._e()] : _vm._e(), _vm.isWidest ? [_vm.authData ? [_c('UserInfo', {
    class: _vm.isWidest ? 'w-mr-12' : 'w-mr-8',
    attrs: {
      "auth-data": _vm.authData
    }
  })] : _vm._e(), _c('r-button-simple', {
    attrs: {
      "icon": "exit",
      "type": "transparent",
      "color": "harakiri",
      "size": "spelino"
    },
    on: {
      "click": function ($event) {
        return _vm.logout();
      }
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }